import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router';
import { AuthService, UserSession } from './auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class SelectActiveRoleGuardService {
	constructor(
		private authService: AuthService,
		private router: Router
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<true | UrlTree> {
		return this.authService.userSession().pipe(
			map((userSession: UserSession) => {
				if (!userSession.token) {
					return this.router.parseUrl('/login');
				}

				const mfaRequired = !!userSession.claims?.mfaRequired;
				if (mfaRequired) {
					return this.router.parseUrl('/');
				}

				const activeEntityRelationshipId =
					userSession.claims?.activeEntityRelationshipId ?? '';
				if (activeEntityRelationshipId !== '') {
					return this.router.parseUrl('/');
				}
				return true;
			})
		);
	}
}
